import * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, size, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "text-foreground bg-white placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground border-border flex w-full min-w-0 rounded-md border-2 px-3 py-1 paragraph-lg shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:font-medium disabled:cursor-not-allowed",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        size ? `h-${size}` : 'h-14',
        className
      )}
      {...props}
    />
  )
}  

export { Input }
